import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'


const FooterImage = () => {

  const {template,variables } = useContext(PassContext)

  const footerImage = dataSelector({template,variables,path:"meta.images.footer"})
  
  if (footerImage) return (
    <PopupEditor title="Strip Image" path="meta.images.strip">
      <img src={footerImage} className="barcode_footer_image"/>
      <div className="barcode_footer_image editable" />
    </PopupEditor>
  )
}

export default FooterImage